"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Fan = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Fan_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 15,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.316 1.163a.755.755 0 0 0-.604 1.21c.721.958 1.315 2.006 1.766 3.117l.553 1.36 1.063-1.837c.989-1.71-.246-3.85-2.222-3.85h-.556Zm.894 6.322-.658-1.619a12.887 12.887 0 0 0-1.639-2.893c-.87-1.157-.045-2.81 1.403-2.81h.556c2.746 0 4.462 2.974 3.087 5.35L8.762 7.586l1.75.225c1.085.14 2.184.142 3.27.007 1.452-.18 2.484 1.378 1.753 2.645l-.27.468c-1.384 2.397-4.846 2.389-6.217-.015L7.894 8.89l-1.023 1.35a12.66 12.66 0 0 0-1.653 2.916c-.541 1.345-2.396 1.47-3.114.211l-.31-.542c-1.357-2.38.362-5.34 3.103-5.34H7.21ZM8.884 8.61l1.5.193c1.169.15 2.351.152 3.52.008a.772.772 0 0 1 .765 1.152l-.27.469c-.998 1.728-3.494 1.721-4.482-.012L8.884 8.61Zm-1.937-.124-.873 1.152a13.66 13.66 0 0 0-1.783 3.147.734.734 0 0 1-1.318.089l-.31-.542c-.977-1.714.26-3.846 2.234-3.846h2.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Fan_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Fan;
exports["default"] = _default;